(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiref400"];
var parcelRegister = parcelRequire.register;
parcelRegister("9XPWH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7411eb1c08c14110$export$2e2bcd8739ae039; });

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");

var $fp3uY = parcelRequire("fp3uY");

var $7411eb1c08c14110$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Product(param) {
        var el = param.el, isLargeQuery = param.isLargeQuery;
        (0, $J7ygF._)(this, Product);
        this.el = el;
        this.isLargeQuery = isLargeQuery;
        this.carouselEl = this.el.querySelector('.carousel .swiper');
        this.currentSlideText = this.el.querySelector('.current-slide');
        // variant picker logic
        this.form = this.el.querySelector('.product-form form');
        this.priceText = document.getElementById('price-text');
        this.submitButton = document.getElementById('submit-button');
        this.currentVariantId = document.getElementById('current_variant_id');
        this.cartCountEls = Array.from(document.querySelectorAll('.cart-count'));
        this.addToCartNotification = document.getElementById('add-to-cart-notification');
        // optionlists. Used to make sure they have made all their selections
        this.optionLists = Array.from(document.querySelectorAll('.option-list'));
        this.init();
    }
    (0, $hvJJn._)(Product, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                if (this.carouselEl) {
                    this.carousel = new (0, $fp3uY.default)(this.carouselEl, {
                        loop: true,
                        slidesPerView: 1,
                        spaceBetween: 0,
                        roundLengths: true,
                        breakpoints: {
                            1024: {
                                slidesPerView: this.carouselEl.dataset.twoUp === 'true' ? 1.99 : 1
                            }
                        }
                    });
                    this.carousel.on('slideChange', function() {
                        if (_this.currentSlideText) _this.currentSlideText.innerHTML = _this.carousel.realIndex + 1;
                    });
                    this.prev = this.el.querySelector('.prev');
                    this.next = this.el.querySelector('.next');
                    if (this.prev) this.prev.addEventListener('click', function() {
                        _this.carousel.slidePrev();
                    });
                    if (this.next) this.next.addEventListener('click', function() {
                        _this.carousel.slideNext();
                    });
                }
                if (this.form) this.form.addEventListener('submit', function(e) {
                    e.preventDefault();
                    // first check if any of the optionlists have no-selection-made class
                    var noSelectionMade = _this.optionLists.some(function(optionList) {
                        return optionList.classList.contains('no-selection-made');
                    });
                    if (noSelectionMade) {
                        alert('Please make all your selections before adding to cart.');
                        return;
                    }
                    _this.submitButton.innerHTML = 'Adding...';
                    var originalFormData = new FormData(_this.form);
                    var notesObj = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // loop through form data entries to get any notes (default gold and default sizes)
                        for(var _iterator = originalFormData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var entry = _step.value;
                            // check if entry starts with 'static-option:'
                            if (entry[0].startsWith('static-option:')) // if it does, set property in notes object
                            notesObj[entry[0].replace('static-option:', '')] = entry[1];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var formData = {
                        items: [
                            {
                                quantity: parseInt(originalFormData.get('quantity')),
                                id: parseInt(originalFormData.get('current_variant_id')),
                                properties: notesObj
                            }
                        ]
                    };
                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData)
                    }).then(function() {
                        _this.successCallback();
                    }).catch(function(error) {
                        console.log(error);
                    });
                });
            }
        },
        {
            key: "successCallback",
            value: function successCallback() {
                var _this = this;
                // track add to cart event for fb
                if (document.body.classList.contains('cookies-accepted')) fbq('track', 'AddToCart');
                fetch('/cart.js').then(function(response) {
                    return response.json();
                }).then(function(data) {
                    // update cart count, submit button
                    _this.submitButton.innerHTML = 'Add to Cart';
                    _this.cartCountEls.forEach(function(el) {
                        el.innerHTML = data.item_count;
                    });
                    _this.addToCartNotification.classList.add('active');
                    document.body.classList.remove('hide-nav');
                    setTimeout(function() {
                        _this.addToCartNotification.classList.remove('active');
                    }, 2000);
                });
            }
        },
        {
            key: "errorCallback",
            value: function errorCallback() {
                alert('There was an error adding your item to cart. Please try again.');
                this.submitButton.innerHTML = 'Add to Cart';
            }
        }
    ]);
    return Product;
}();

});
parcelRegister("J7ygF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $087a0fb22a93b2d1$export$71511d61b312f219; });
function $087a0fb22a93b2d1$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hvJJn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbf8ce221d4c5514$export$71511d61b312f219; });
function $cbf8ce221d4c5514$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cbf8ce221d4c5514$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});


parcelRegister("5vuqB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $40277363b68668b9$export$71511d61b312f219; });
function $40277363b68668b9$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("ltnlO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fa1e6b5e4cf4e6cf$export$71511d61b312f219; });

var $5vuqB = parcelRequire("5vuqB");
function $fa1e6b5e4cf4e6cf$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5vuqB._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("1WOPg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $16b2a2272a36e4b4$export$71511d61b312f219; });
function $16b2a2272a36e4b4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $16b2a2272a36e4b4$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $16b2a2272a36e4b4$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("5ZV7E", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $45def593611ffc53$export$71511d61b312f219; });

var $dakGr = parcelRequire("dakGr");

var $3iELS = parcelRequire("3iELS");

var $lbIZx = parcelRequire("lbIZx");

var $6HNFp = parcelRequire("6HNFp");
function $45def593611ffc53$export$71511d61b312f219(arr, i) {
    return (0, $dakGr._)(arr) || (0, $3iELS._)(arr, i) || (0, $6HNFp._)(arr, i) || (0, $lbIZx._)();
}

});
parcelRegister("dakGr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $995c40d652b0553f$export$71511d61b312f219; });
function $995c40d652b0553f$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("3iELS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2672addbd595e189$export$71511d61b312f219; });
function $2672addbd595e189$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("lbIZx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f6cd8669e12714d8$export$71511d61b312f219; });
function $f6cd8669e12714d8$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("6HNFp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4e1d490ad7b9bee1$export$71511d61b312f219; });

var $84Wdk = parcelRequire("84Wdk");
function $4e1d490ad7b9bee1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $84Wdk._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $84Wdk._)(o, minLen);
}

});
parcelRegister("84Wdk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5e1bda8aa9cfef6d$export$71511d61b312f219; });
function $5e1bda8aa9cfef6d$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("5euqn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3cf5dc3c2ce8e525$export$71511d61b312f219; });
function $3cf5dc3c2ce8e525$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

})();
//# sourceMappingURL=Product.bec0f69e.js.map
